module.exports = __webpack_public_path__ + "static/media/con_spa_tag_on_off.bae31f47.png";